import React from "react";
import {
  MainContainer,
  ImageContainer,
  Title,
  Description,
  ReedMore,
} from "./SectionItem.styles";
import { NavLink } from "react-router-dom";

const SectionItem = ({
  title,
  slug,
  category,
  author,
  image,
  excerpt,
  description,
  handleReedMore,
}) => {
  return (
    <MainContainer>
      <ImageContainer>{image}</ImageContainer>
      <Title>{title}</Title>
      {excerpt && (
        // <Description>{`${excerpt
        //   .split(" ")
        //   .slice(0, 50)
        //   .join(" ")}...`}</Description>
        <Description>{excerpt}</Description>
      )}

      <NavLink to={`/${category}/${slug}`} style={{ textDecoration: "none" }}>
        <ReedMore>Leer más</ReedMore>
      </NavLink>
      {/* <ReedMore
        slug={slug}
        // handleClick={handleReedMore}
        fullElement={{ title, author, description }}
      /> */}
    </MainContainer>
  );
};

export default SectionItem;
